export default __webpack_public_path__ + "content/3efd5ba15a279377d224281c1ac26b53.woff2";